import { baseServiceRequest } from "@apis/baseServiceRequest"
import type { IAccountTransaction } from "./types"

export const getAccountTransactions = async (
  account_id: string,
): Promise<IAccountTransaction[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/internal/accounts/${account_id}/transactions`,
  })
  return response.data
}

export const getPossibleAccountTransactions = async (
  account_id: string,
): Promise<IAccountTransaction[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/internal/accounts/${account_id}/possible_transactions`,
  })
  return response.data
}

export const assignAccountTransaction = async ({
  account_transaction_id,
  data,
}: {
  account_transaction_id: number
  data: { account_id: string }
}) => {
  return baseServiceRequest({
    method: "PUT",
    url: `/internal/account_transactions/${account_transaction_id}`,
    data: data,
    skipAuditInterceptor: true
  })
}
